export enum RequisitionPOStatusEnum {
    Draft = 1,
    SubmittedForApproval = 2,
    Rejected = 3,
    AmendRequired = 4,
    Approved = 5,
}
